import React from 'react'
import {connect} from 'react-redux'
import {
    Icon,
} from 'antd'
import './style.scss'
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
class HomeCarousel extends React.Component{
    constructor(props){
        super(props);
        this.state = {

        }
    }
    render(){
        
        if(!this.props.Content){ 
            return(
                <div className="">spin?</div>
            )
        }else{
            const {content, isLoading} = this.props.Content
           if(isLoading){
            return(
                <div className="">spin?</div>
            )
           }else{
            const {overlay, images} = content.Carousel
            return (
                <div className="Carousel">
                    <Carousel
                    infiniteLoop={true}
                    autoPlay={true}
                    showIndicators={false}
                    showStatus={false}
                    dynamicHeight={true}
                    showArrows={false}
                    showThumbs={false}
                    >
                        {images.map((image) => 
                            <div className="">
                                <img src={image} alt={image} />
                            </div>
                        )}
                    </Carousel>
                    <div className="overlay">
                        <div className="contact">
                            <div className="item">
                                <Icon className="phone" type="phone" />
                                <p className="">
                                    {overlay.phone}
                                </p>
                            </div>
                            <div className="item">
                                <Icon className="email" type="mail" />
                                <p className="">
                                    {overlay.email}
                                </p>
                            </div>
                        </div>
                    </div>
                    <svg class="facebook" viewBox="0 2.25 66 66">
                        <path fill="rgba(66,103,178,0.929)" id="Icon_awesome_facebook_square" d="M 58.92857360839844 2.250000238418579 L 7.071428775787354 2.250000238418579 C 3.16598653793335 2.250000238418579 -9.990874332288513e-07 5.415987968444824 0 9.321430206298828 L 0 61.17857360839844 C 0 65.08401489257813 3.165986776351929 68.25 7.071429252624512 68.25 L 27.29129600524902 68.25 L 27.29129600524902 45.81147384643555 L 18.01004600524902 45.81147384643555 L 18.01004600524902 35.25 L 27.29129600524902 35.25 L 27.29129600524902 27.20035934448242 C 27.29129600524902 18.04433250427246 32.7421875 12.98678588867188 41.09089660644531 12.98678588867188 C 45.08919906616211 12.98678588867188 49.27017974853516 13.69982242584229 49.27017974853516 13.69982242584229 L 49.27017974853516 22.68642997741699 L 44.6634407043457 22.68642997741699 C 40.12446594238281 22.68642997741699 38.70870590209961 25.50321578979492 38.70870590209961 28.39219093322754 L 38.70870590209961 35.25 L 48.84147644042969 35.25 L 47.22093963623047 45.81147384643555 L 38.70870590209961 45.81147384643555 L 38.70870590209961 68.25 L 58.92857360839844 68.25 C 62.83401107788086 68.25 66 65.08401489257813 66 61.17857360839844 L 66 9.321429252624512 C 66 5.415987014770508 62.83401107788086 2.250000238418579 58.92856979370117 2.250000238418579 Z">
                        </path>
                    </svg>
                </div>
            )
           }
        }
    }
}

const mapStateToProps = (store) => ({
    Content: store.content
  })
  export default connect(mapStateToProps)(HomeCarousel);